import { Button, Col, DatePicker, Input, message, Modal, Row, Select, Space, Form } from "antd"
import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons'
import _ from 'lodash'
import { apiPrefix } from "../../../js/config"
import { useForm } from "antd/lib/form/Form"
import moment from "moment"

const { Option } = Select

interface Prop {
    checkInID?: string
    onChange?: () => void
}

export default function (prop: Prop) {

    const param: { check_in_id: string } = useParams()

    const [visible, setVisible] = useState<boolean>(false)
    const [form] = useForm()

    const [types, setTypes] = useState<any[]>([])
    const [foods, setFoods] = useState<any[]>([])

    const [foodTypeID1, setFoodTypeID1] = useState<string>()
    const [foodTypeID2, setFoodTypeID2] = useState<string>()

    const [foodID1, setFoodID1] = useState<string[]>([])
    const [foodID2, setFoodID2] = useState<string[]>([])

    useEffect(() => {
        baseAxiosNoInfo('/cooking_center/global/food_type_list').then((res: any) => {
            res && setTypes(res)
        })
    }, [])

    const onFinish = () => {
        if (foodTypeID1 && foodID1.length === 0) {
            message.error('如果选择了菜品分类，则必须选择食材')
            return
        }

        if (foodTypeID2 && foodID2.length === 0) {
            message.error('如果选择了菜品分类，则必须选择食材')
            return
        }

        baseAxiosComplete.post('/cooking_center/customer/dietician_check/add', {
            check_in_id: param.check_in_id,
            check_date: form.getFieldValue('check_date') && form.getFieldValue('check_date').format('YYYY-MM-DD'),
            guomin_food_item_id: foodID1,
            jinji_food_item_id: foodID2,
            check_content: form.getFieldValue('check_content'),
        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
                prop.onChange && prop.onChange()
            }
        })
    }

    return <Fragment>
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>营养师查房</Button>

        {/* 膳食中心 -> 营养膳食 -> 入住客户管理 -> 客户详情 -> 录入营养师查房 */}
        <Modal title="录入营养师查房" width={1200} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <div>
                <Form form={form}>
                    <Form.Item label="查房日期" name="check_date" rules={[{ required: true, message: '查房日期不能为空' }]} >
                        <DatePicker />
                    </Form.Item>

                    <Form.Item label="过敏食材"  >
                        <Space>
                            <Select placeholder="选择食材分类" value={foodTypeID1}
                                showSearch
                                onChange={(v: string) => {
                                    setFoodTypeID1(v)
                                    baseAxiosNoInfo('/cooking_center/global/food_item_list', {
                                        params: {
                                            food_type_id: v
                                        }
                                    }).then(((res: any) => {
                                        res && setFoods(res)
                                    }))
                                }}
                                filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                            >
                                {types.map((el: any) => <Option key={el.food_type_id} value={el.food_type_id}>{el.food_type_name}</Option>)}
                            </Select>

                            <Select placeholder="选择食材" style={{ minWidth: 150 }} mode="multiple"
                                showSearch
                                onChange={(v: string[]) => {
                                    setFoodID1(v)
                                }}
                                filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                            >
                                {foods.map((el: any) => <Option key={el.food_item_id} value={el.food_item_id}>{el.food_item_name}</Option>)}
                            </Select>
                        </Space>
                    </Form.Item>

                    <Form.Item label="禁忌食材" >
                        <Space>
                            <Select placeholder="选择食材分类" value={foodTypeID2}
                                showSearch
                                onChange={(v: string) => {
                                    setFoodTypeID2(v)
                                    baseAxiosNoInfo('/cooking_center/global/food_item_list', {
                                        params: {
                                            food_type_id: v
                                        }
                                    }).then(((res: any) => {
                                        res && setFoods(res)
                                    }))
                                }}
                                filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                            >
                                {types.map((el: any) => <Option key={el.food_type_id} value={el.food_type_id}>{el.food_type_name}</Option>)}
                            </Select>

                            <Select placeholder="选择食材" style={{ minWidth: 150 }} mode="multiple"
                                showSearch
                                onChange={(v: string[]) => {
                                    setFoodID2(v)
                                }}
                                filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                            >
                                {foods.map((el: any) => <Option key={el.food_item_id} value={el.food_item_id}>{el.food_item_name}</Option>)}
                            </Select>
                        </Space>
                    </Form.Item>

                    <Form.Item label="查房内容" name="check_content">
                        <Input />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    </Fragment>
}